"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaqSubtopicFromJSON = FaqSubtopicFromJSON;
exports.FaqSubtopicFromJSONTyped = FaqSubtopicFromJSONTyped;
exports.FaqSubtopicToJSON = FaqSubtopicToJSON;
exports.FaqSubtopicToJSONTyped = FaqSubtopicToJSONTyped;
const _1 = require("./");
function FaqSubtopicFromJSON(json) {
    return FaqSubtopicFromJSONTyped(json, false);
}
function FaqSubtopicFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'label': json['label'],
        'tag': json['tag'],
        'questions': (json['questions'].map(_1.FaqSubtopicQuestionFromJSON)),
    };
}
function FaqSubtopicToJSON(value) {
    return FaqSubtopicToJSONTyped(value, false);
}
function FaqSubtopicToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'label': value.label,
        'tag': value.tag,
        'questions': (value.questions.map(_1.FaqSubtopicQuestionToJSON)),
    };
}
